import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot} from '@angular/router';
import {ValidationType} from '@core/api/data-access';

import {ValidatorService} from '../services';

export const onFailValidationNavTo = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
	return ['sign', route.firstChild.params.id];
};

export function canActivateValidation(validationType: ValidationType, onFailNavTo: (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => string[]): CanActivateFn {
	return (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
		const validatorService: ValidatorService = inject(ValidatorService);
		const router: Router = inject(Router);

		const hasTests: boolean = validatorService.store.hasTests();
		if (!hasTests && onFailNavTo) return navigateTo(onFailNavTo(route, state), router, route);
		const tests = validatorService.store.tests();
		if (tests) {
			validatorService.store.rebuildTests();
			const hasTypeTest = tests.find(test => test.schema.type === validationType);
			return hasTypeTest ? true : navigateTo(onFailNavTo(route, state), router, route);
		}
		return navigateTo(onFailNavTo(route, state), router, route);
	};

	function navigateTo(navTo: string[], router: Router, route: ActivatedRouteSnapshot): Promise<boolean> {
		// navigate to the next test
		return router.navigate(navTo);
	}
}
